import React from 'react'
import styled from 'styled-components'
import {
  ConsoleCard,
  CardsCol,
  CardsRow,
  PageHeading,
  Page,
} from 'admin-web-ui'
import {
  CallDurationChart,
  CallVolumeChart,
  CallsByCountryChart,
  DailyPhoneActivityChart,
} from '../charts'

const StyledConsoleCard = styled(ConsoleCard)`
  .ant-card-body > * {
    margin-bottom: 30px;

    :last-child {
      margin-bottom: 0;
    }
  }
`

export const VoiceCallingDashboard: React.FC = () => {
  return (
    <Page>
      <PageHeading>Voice Calling Dashboard</PageHeading>

      <CardsRow>
        <CardsCol span={24}>
          <ConsoleCard>
            <DailyPhoneActivityChart />
          </ConsoleCard>
        </CardsCol>
      </CardsRow>

      <CardsRow gutter={32}>
        <CardsCol span={12}>
          <StyledConsoleCard>
            <CallVolumeChart />
            <CallDurationChart />
          </StyledConsoleCard>
        </CardsCol>
        <CardsCol span={12}>
          <ConsoleCard>
            <CallsByCountryChart />
          </ConsoleCard>
        </CardsCol>
      </CardsRow>
    </Page>
  )
}
